export type IneligibilityReasonUnknown = {
  type: 'unknown';
  strategy: IneligibilityHandlingStrategy.DisableInteractions;
};
export type IneligibilityReasonNonEnoughPoints = {
  type: 'not_enough_points';
  strategy: IneligibilityHandlingStrategy.DisableInteractions;
};
export type IneligibilityReasonPurchasableEligibilityConstraintFailed = {
  type: 'purchasable_eligibility_constraint_failed';
  strategy: IneligibilityHandlingStrategy.DisableLoyaltyAction;
};

export type IneligibilityReason =
  | IneligibilityReasonUnknown
  | IneligibilityReasonNonEnoughPoints
  | IneligibilityReasonPurchasableEligibilityConstraintFailed;

/**
 * Determines how to handle non-eligible offer
 * If hide strategy is used - no further processing is expected
 */
export enum IneligibilityHandlingStrategy {
  Hide = 'hide',
  DisableInteractions = 'disable',
  DisableLoyaltyAction = 'disable_loyalty_action',
}

export type Eligible = [true] | [false, IneligibilityHandlingStrategy, IneligibilityReason[]];
